import { registerCountryPlugin } from '@/core/plugins/country-plugin'
import OmanCheckoutModule from './modules/checkout/checkout.module'
import OmanPaymentsModule from './modules/payments/payments.module'

registerCountryPlugin({
    slug: 'oman',
    code: 'OMN',
    CheckoutModule: OmanCheckoutModule,
    PaymentsModule: OmanPaymentsModule
})
